// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This style file is imported by CsVersionTable.js which is a part of Customer solution dashboard page.
*/

.table-container-cs {
  width: 80% !important;
  margin: 2% auto;
}

.cs-table-div-tbody {
  display: block;
  max-height: 65vh; 
  overflow-y: auto;        /* Enable vertical scroll */
  overflow-x: hidden;
}

.cs-table-div-tbody::-webkit-scrollbar {
  width: 8px;
}
.cs-table-div-tbody::-webkit-scrollbar-track {
  background: #f2f2f2;
  border-radius: 8px;
}
.cs-table-div-tbody::-webkit-scrollbar-thumb {
  background: #0C3135;
  border-radius: 8px;
}
.cs-table-div-tbody::-webkit-scrollbar-thumb:hover {
  background: #2a5a5a;
}

.cs-table-thead{
  background-color: #f2f2f2;
  position: sticky;
  top: 0; /* Sticks to the top */
  z-index: 2;
}

.time-container-cs {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 1% 1% !important;
  gap: 1% !important; 
  margin-top: 4%;
}

.cs-table {
  width: 100% !important;
  border-collapse: collapse;
  margin-top: 15px;
}

.cs-td {
  border: 1px solid #ddd;
  text-align: left !important;
  padding: 8px 12px;
  word-wrap: break-word;
}

.cs-th {
  top:0;
  position: sticky;
  background-color: #0C3135;
  border: 1px solid #ddd;
  text-align: center !important;
  padding: 8px 12px;
  min-width: 120px;
  max-width: 225px;
  max-height: 55vh;
}

.cs-table tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.tr-cs:nth-child(even) {
  background-color: #f9f9f9;
}

.refresh-button-cs {
  background-color: #0C3135;
  color: white;
  font-size: 15px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  padding: 0.5rem;
  height: 2.0rem !important; 
  width: 2.0rem; 
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0; 
}

.refresh-button-cs:hover {
  background-color: #2a5a5a;
}

.table-header-content-cs {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding: 0 5px;
}

.table-heading-cs-mvc{
  margin-right: 10%;
}


.sort-arrows-cs {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.arrow-cs {
  cursor: pointer;
  font-size: 12px;
  line-height: 1;
  -webkit-user-select: none;
          user-select: none;
  color: rgba(255, 255, 255, 0.8);
  transition: color 0.2s ease;
}

.arrow-cs:hover {
  color: white;
}



@media screen and (max-width: 321px) {
  .table-container-cs {
    width: 90% !important;
  }

  .time-container-cs {
    padding: 2% 5%;
    margin-top: 20%;
    gap: 2%; 
  }
  .cs-table{
    width:90% !important;
    margin-left: 12%;
  }
}

@media (min-width: 321px) and (max-width: 376px)  {
  .table-container-cs {
    width: 90% !important;
  }

  .time-container-cs {
    padding: 2% 2%;
    margin-top: 20%;
    gap: 2%; 
  }
  .cs-table{
    width:95% !important;
    margin-left: 8%;
  }
}

@media  (min-width: 376px) and (max-width: 426px)  {
  .table-container-cs {
    width: 90% !important;
  }

  .time-container-cs {
    padding: 1% 1%;
    margin-top: 20%;
    gap: 2%; 
  }
  .cs-table{
    width:95% !important;
    margin-left: 8%;
  }
}

@media (min-width: 426px) and (max-width: 769px) {
  .table-container-cs {
    width: 90% !important;
  }

  .time-container-cs {
    padding: 0% 0%;
    margin-top: 8%;
    gap: 2%; 
  }
  .cs-table{
    width:97% !important;
    margin-left: 5%;
  }
}

@media (min-width: 769px) and (max-width: 1025px) {
  .time-container-cs {
    padding: 0% 0%;
    margin-top: 5%;
    gap: 2%; 
  }
}

@media (min-width: 1921px){
  .cs-table thead{
    font-size: 22px !important;
  }
  .cs-table tbody{
    font-size: 22px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomerSolutionDashboard/CsVersionTable.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB,SAAS,2BAA2B;EACpD,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM,EAAE,sBAAsB;EAC9B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,KAAK;EACL,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;;;AAIA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,OAAO;EACT;EACA;IACE,oBAAoB;IACpB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,OAAO;EACT;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,OAAO;EACT;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,OAAO;EACT;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;IACd,cAAc;IACd,OAAO;EACT;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/*\nThis style file is imported by CsVersionTable.js which is a part of Customer solution dashboard page.\n*/\n\n.table-container-cs {\n  width: 80% !important;\n  margin: 2% auto;\n}\n\n.cs-table-div-tbody {\n  display: block;\n  max-height: 65vh; \n  overflow-y: auto;        /* Enable vertical scroll */\n  overflow-x: hidden;\n}\n\n.cs-table-div-tbody::-webkit-scrollbar {\n  width: 8px;\n}\n.cs-table-div-tbody::-webkit-scrollbar-track {\n  background: #f2f2f2;\n  border-radius: 8px;\n}\n.cs-table-div-tbody::-webkit-scrollbar-thumb {\n  background: #0C3135;\n  border-radius: 8px;\n}\n.cs-table-div-tbody::-webkit-scrollbar-thumb:hover {\n  background: #2a5a5a;\n}\n\n.cs-table-thead{\n  background-color: #f2f2f2;\n  position: sticky;\n  top: 0; /* Sticks to the top */\n  z-index: 2;\n}\n\n.time-container-cs {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 1% 1% !important;\n  gap: 1% !important; \n  margin-top: 4%;\n}\n\n.cs-table {\n  width: 100% !important;\n  border-collapse: collapse;\n  margin-top: 15px;\n}\n\n.cs-td {\n  border: 1px solid #ddd;\n  text-align: left !important;\n  padding: 8px 12px;\n  word-wrap: break-word;\n}\n\n.cs-th {\n  top:0;\n  position: sticky;\n  background-color: #0C3135;\n  border: 1px solid #ddd;\n  text-align: center !important;\n  padding: 8px 12px;\n  min-width: 120px;\n  max-width: 225px;\n  max-height: 55vh;\n}\n\n.cs-table tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n}\n\n.tr-cs:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.refresh-button-cs {\n  background-color: #0C3135;\n  color: white;\n  font-size: 15px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  padding: 0.5rem;\n  height: 2.0rem !important; \n  width: 2.0rem; \n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0; \n}\n\n.refresh-button-cs:hover {\n  background-color: #2a5a5a;\n}\n\n.table-header-content-cs {\n  display: flex;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  padding: 0 5px;\n}\n\n.table-heading-cs-mvc{\n  margin-right: 10%;\n}\n\n\n.sort-arrows-cs {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.arrow-cs {\n  cursor: pointer;\n  font-size: 12px;\n  line-height: 1;\n  user-select: none;\n  color: rgba(255, 255, 255, 0.8);\n  transition: color 0.2s ease;\n}\n\n.arrow-cs:hover {\n  color: white;\n}\n\n\n\n@media screen and (max-width: 321px) {\n  .table-container-cs {\n    width: 90% !important;\n  }\n\n  .time-container-cs {\n    padding: 2% 5%;\n    margin-top: 20%;\n    gap: 2%; \n  }\n  .cs-table{\n    width:90% !important;\n    margin-left: 12%;\n  }\n}\n\n@media (min-width: 321px) and (max-width: 376px)  {\n  .table-container-cs {\n    width: 90% !important;\n  }\n\n  .time-container-cs {\n    padding: 2% 2%;\n    margin-top: 20%;\n    gap: 2%; \n  }\n  .cs-table{\n    width:95% !important;\n    margin-left: 8%;\n  }\n}\n\n@media  (min-width: 376px) and (max-width: 426px)  {\n  .table-container-cs {\n    width: 90% !important;\n  }\n\n  .time-container-cs {\n    padding: 1% 1%;\n    margin-top: 20%;\n    gap: 2%; \n  }\n  .cs-table{\n    width:95% !important;\n    margin-left: 8%;\n  }\n}\n\n@media (min-width: 426px) and (max-width: 769px) {\n  .table-container-cs {\n    width: 90% !important;\n  }\n\n  .time-container-cs {\n    padding: 0% 0%;\n    margin-top: 8%;\n    gap: 2%; \n  }\n  .cs-table{\n    width:97% !important;\n    margin-left: 5%;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1025px) {\n  .time-container-cs {\n    padding: 0% 0%;\n    margin-top: 5%;\n    gap: 2%; \n  }\n}\n\n@media (min-width: 1921px){\n  .cs-table thead{\n    font-size: 22px !important;\n  }\n  .cs-table tbody{\n    font-size: 22px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
